<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <template v-if="curSysKey === 'course'">
      <school-year />
    </template>
    <div class="right-menu">
      <error-log class="errLog-container right-menu-item hover-effect" />
      <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->
      <div class="right-menu-item">
        <div class="avatar-wrapper">
          <!-- <el-radio-group v-model="curSysKey" class="inline-block m-r-10" size="small">
            <el-radio-button label="course">课程</el-radio-button>
            <el-radio-button label="ticket">票务</el-radio-button>
            <el-radio-button label="community">社区</el-radio-button>
          </el-radio-group> -->
          <span class="m-r-10">{{ now }}</span>
          <span class="m-r-10">欢迎回来，{{ user.info.real_name }}</span>
          <el-dropdown trigger="click">
            <el-badge :value="sysMessage.length" class="sys-message" v-show="sysMessage.length">
              <i class="el-icon-bell"></i>
            </el-badge>
            <i class="el-icon-bell" v-show="!sysMessage.length"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in sysMessage" :key="item.id" @click.native="showMessageDetail(item)">{{
                item.title
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="text" size="small" class="m-l-10 m-r-10 logout" @click.native="logout">退出</el-button>
        </div>
      </div>
    </div>
    <sys-message :visible.sync="isShow" :curItem="curItem" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Badge, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import { mapGetters } from 'vuex';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import SysMessage from '@/components/SysMessage';
import utils from '@/utils';
import { getCurrentSysMsg, logger, readSysMsg } from '@/api';
import SchoolYear from './SchoolYear';

export default {
  name: 'Navbar',
  components: {
    Hamburger,
    ErrorLog,
    SchoolYear,
    ElBadge: Badge,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu,
    SysMessage
  },
  data() {
    return {
      sysMessage: [],
      isShow: false,
      curItem: {},
      timer: '',
      now: '',
      indexPath: {
        course: utils.COURSE_INDEX_PATH,
        ticket: '/ticket/sector',
        community: utils.COMMUNITY_INDEX_PATH
      }
    };
  },
  watch: {
    user: {
      handler(val) {
        this.initPassWord(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'user']),
    curSysKey: {
      set(value) {
        this.$store.dispatch('app/changeSys', value);
        this.$store.dispatch('tagsView/delAllViews');
        this.$nextTick(() => {
          this.$router.push(`/${this.$route.params.user_id}${this.indexPath[value]}`);
        });
      },
      get() {
        return this.$store.state.app.curSysKey;
      }
    }
  },
  mounted() {
    if (!this.user.info.username) {
      this.$store.dispatch('user/addUser');
    } else {
      this.initPassWord(this.user);
    }
    this.getCur();
    this.setTime();
    const { sys_type } = this.$route.params;
    if (sys_type) this.$store.dispatch('app/changeSys', sys_type);
  },
  methods: {
    initPassWord(val) {
      // 首次登陆强制修改密码
      const path = `/${this.$store.state.user.info.id}/personal/base`;
      if (val.info && val.info.is_need_update_password && this.$route.query.is_need_update_password !== 'true') {
        this.$router.push(`${path}?is_need_update_password=true`);
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    getCur() {
      getCurrentSysMsg().then(({ data }) => {
        this.sysMessage = data.list;
      });
    },
    logout() {
      logger.fetchLoggerPost({
        module: 1,
        event_type: 2,
        cusp: `${this.user.info.real_name}退出登录`,
        status: 1
      }).then(() => {
        this.$store.dispatch('user/logout');
      });
    },
    showMessageDetail(item) {
      this.curItem = item;
      this.isShow = true;
      readSysMsg({ msg_id: item.id }).then(res => {
        if (res) this.getCur();
      });
    },
    setTime() {
      this.timer = window.setInterval(() => {
        this.now = dayjs().format('YYYY年MM月DD日 HH:mm:ss');
      }, 0);
    }
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.navbar {
  min-width: 1000px;
  height: @navBarTopHeight;
  overflow: hidden;
  position: relative;
  background: #fff;

  .hamburger-container {
    line-height: @navBarTopHeight;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: @navBarTopHeight;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .sys-message {
    line-height: 1;
    cursor: pointer;
  }
  .el-icon-bell {
    font-size: 18px;
  }
  .el-dropdown {
    line-height: 1;
    height: 0;
  }
  .logout {
    font-size: 14px;
    position: relative;
    bottom: 1px;
  }
}
</style>
